<template>
  <v-container fill-height>
    <v-row align="center" justify="center">
        <v-card
          width="400"
          class="py-6 px-10 text-center"
          elevation="4"
          style="margin-top: -20px; min-width: 300px"
        >
          <img src="@/assets/logo.png" style="max-height: 40px" />
          <div class="mt-8 text-h6" style="color: #31708f">Inicio de sesión</div>
          <v-text-field
            class="mt-5"
            v-model="datosUsuario.correo"
            label="Correo electrónico"
            prepend-inner-icon="mdi-email"
            required
            type="email"
            @keypress.enter="enfocarContrasena"
            @blur="completarEmail"
          ></v-text-field>

          <v-text-field
            label="Contraseña"
            v-model="datosUsuario.contrasena"
            prepend-inner-icon="mdi-account-key"
            required
            @keypress.enter="login"
            ref="contrasena"
            :type="verContrasena ? 'text' : 'password'"
            :append-icon="verContrasena ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="verContrasena = !verContrasena"
          ></v-text-field>

          <v-btn
            :disabled="!datosRellenos"
            color="orange"
            @click="login"
            class="mt-2 white--text"
            elevation="2"
            large
            block

          >
            Login
          </v-btn>


        <v-btn
          color="orange"
          class="ma-2 white--text"
          @click="recuperarContrasenaOlvidada"
          text
        >
          ¿Olvidó su contraseña?
        </v-btn>
      </v-card>
      <dialogoCorreo ref="dialogoCorreo" @keypress.esc="clickFuera" />
    </v-row>
  </v-container>
</template>

<script>
import ApiZD from "../apiZonaDeDescargas";
import dialogoCorreo from "./dialogoCorreo";
export default {
  components: {
    dialogoCorreo,
  },
  data() {
    return {
      verContrasena: false,
      deshabilitado: false,
      datosUsuario: {
        correo: "",
        contrasena: "",
      },
    };
  },
  methods: {
    completarEmail() {
      if (this.datosUsuario.correo != "" && !this.datosUsuario.correo.includes("@"))
        this.datosUsuario.correo = this.datosUsuario.correo + "@equinsa.es"
    },
    // Funcion para logarse
    login() {
      this.deshabilitado = true;
      if (
        this.datosUsuario.correo === "" ||
        this.datosUsuario.contrasena === ""
      ) {
        this.$root.$dialogo
          .activarDialogo(
            "Datos vacios",
            "Debes rellenar todos los campos para poder acceder",
            ["OK"]
          )
          .finally(() => {
            this.deshabilitado = false;
          });
      } else {
        //Si no ha especificado dominio se añade el equinsa
        if (this.datosUsuario.correo != "" && !this.datosUsuario.correo.includes("@"))
          this.datosUsuario.correo = this.datosUsuario.correo + "@equinsa.es"

        ApiZD.login(this.datosUsuario.correo, this.datosUsuario.contrasena)
          .then((resultado) => {
            this.$root.$estadoApp.establecerUsuario(
              this.datosUsuario.correo,
              resultado.data.token,
              resultado.data.admin,
              resultado.data.compartir
            );
            this.$router.push({ path: "/principal" }); // Vamos a la vista principal
          })
          .catch((e) => {
            this.$root.$dialogo
              .activarDialogo(
                "Error al iniciar sesión",
                e.data.descripcion_error,
                ["Cerrar"]
              )
              .finally(() => {
                this.deshabilitado = false;
              });
          });
      }
    },
    enfocarContrasena() {
      this.$refs.contrasena.focus();
    },

    //Funcion para recuperar la contraseña
    recuperarContrasenaOlvidada() {
      this.$refs.dialogoCorreo
        .activarDialogo(this.datosUsuario.correo)
        .then((correoEspecificadoPorUsuario) => {
          if (correoEspecificadoPorUsuario == "") {
            this.$root.$dialogo.activarDialogo(
              "Dato vacio",
              "Debes rellenar el campo del correo  para poder recuperar tu contraseña",
              ["OK"]
            );
          } else {
            this.$estadoApp.cargando = true;
            ApiZD.envioCorreoRecuperacionContrasena(
              correoEspecificadoPorUsuario
            )
              .then(() => {
                this.$root.$dialogo.activarDialogo(
                  "Email enviado",
                  "Se ha enviado un correo a " +
                    correoEspecificadoPorUsuario +
                    " con los pasos a seguir para recuperar la contraseña.",
                  ["Cerrar"]
                );
              })
              .catch(() => {
                this.$root.$dialogo.activarDialogo(
                  "Error al recuperar la contraseña",
                  "El correo indicado no pertenece a ningun usuario.",
                  ["Cerrar"]
                );
              })
              .finally(() => {
                this.$estadoApp.cargando = false;
              });
          }
        })
        .catch((e) => {
        });
    },
  },
  computed: {
    datosRellenos() {
      return (this.datosUsuario.correo != "" && this.datosUsuario.contrasena != "")
    },
  },
  created() {
    this.datosUsuario.correo = this.$estadoApp.emailLogin;
  },
};
</script>


<style scoped>
.ancho-maximo {
  max-width: 300px;
}
</style>
